import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { RouteIds, Step } from '../types';
import { StepsDefinitionService } from './steps-definition.service';

/**
 * Service to resolve step definitions for routes
 * Following the quote-tool-lite pattern
 *
 * This resolver is called during route activation, at which point
 * translations are already loaded and $localize will work correctly.
 */
@Injectable({
  providedIn: 'root',
})
export class StepResolverService {
  private readonly stepsDefinitionService = inject(StepsDefinitionService);

  /**
   * Resolves the step definition for a given route
   * Called during route activation - translations are already loaded at this point
   *
   * @param stepId - The route identifier for the step
   * @returns Observable of the step definition with translated content
   */
  resolve(stepId: RouteIds): Observable<Step> {
    const step = this.stepsDefinitionService.getStepDefinition(stepId);
    return of(step);
  }
}
